import { useTranslation } from 'react-i18next';

import { fmtInt } from 'src/sections/@dashboard/home/metricas/MetricasUI';
import { MKT_CTWA_DESIGN as d } from 'src/pages/dashboard/Marketing/MarketingCtwa.design';
import {
    nomeAnuncio,
    plataformaAnuncio,
    PLATAFORMA_COR,
    rotuloMidia,
    truncarTexto,
    formatarUltimoContatoCapturado,
} from './ctwa.utils';
import CtwaAnuncioThumb from './CtwaAnuncioThumb';

export default function CtwaAnuncioCard({ anuncio, index, maxTotal, onClick }) {
    const { t } = useTranslation('marketing');
    const plataforma = plataformaAnuncio(anuncio.source_url);
    const proporcao = maxTotal > 0 ? Math.round((anuncio.total / maxTotal) * 100) : 0;
    const titulo = nomeAnuncio(anuncio);
    const copy = truncarTexto(anuncio.body, 100);
    const ultimoContato = formatarUltimoContatoCapturado(anuncio.ultimaEntrada);

    return (
        <article
            className={`${d.adCard} ${onClick ? d.adCardClickable : ''}`}
            onClick={onClick}
            onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
        >
            <CtwaAnuncioThumb anuncio={anuncio} titulo={titulo} />

            <div className={d.adMain}>
                <div className={d.adTop}>
                    <div className="min-w-0 flex-1">
                        <div className={d.adRankLine}>
                            <span className={d.adRank}>#{index + 1}</span>
                            <span className={d.adPlatform} style={{ color: PLATAFORMA_COR[plataforma.id] }}>
                                {plataforma.label}
                            </span>
                            {anuncio.media_type && (
                                <span className={d.adMuted}>· {rotuloMidia(anuncio.media_type, t)}</span>
                            )}
                        </div>
                        <h4 className={d.adHeadline}>{titulo}</h4>
                        {copy ? <p className={d.adCopy}>{copy}</p> : null}
                    </div>
                    <div className={d.adMetrics}>
                        <div>
                            <span className={d.adMetricVal}>{fmtInt(anuncio.total)}</span>
                            <span className={d.adMetricLbl}>{t('ctwaPage.table.entries')}</span>
                        </div>
                        <div>
                            <span className={d.adMetricVal}>{fmtInt(anuncio.contatosUnicos)}</span>
                            <span className={d.adMetricLbl}>{t('ctwaPage.table.contacts')}</span>
                        </div>
                    </div>
                </div>

                <div className={d.adBarTrack}>
                    <div className={d.adBarFill} style={{ width: `${proporcao}%` }} />
                </div>

                <div className={d.adFooter}>
                    <div className="min-w-0">
                        <span className={d.adId}>
                            {anuncio.source_id !== 'sem_id' ? anuncio.source_id : t('ctwaPage.adCard.noId')}
                        </span>
                        {ultimoContato ? (
                            <p className={d.adLastContact} title={ultimoContato}>
                                {t('ctwaPage.adCard.lastContact', { date: ultimoContato })}
                            </p>
                        ) : null}
                    </div>
                    {anuncio.source_url ? (
                        <a
                            href={anuncio.source_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={d.adLink}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {t('ctwaPage.adCard.openAd')} ↗
                        </a>
                    ) : null}
                </div>
            </div>
        </article>
    );
}
